'use strict';

angular.module('ntmApp')
  .directive('progressCompletedBar', function () {
      return {
          restrict: 'E',
          templateUrl: 'ng1/src/directives/templates/progressBar.html',
          scope: {
              value: '=',
              data: '=',
              hideValue: '=',
              decimals: '='
          },
          link: function (scope) {
              scope.decimals = scope.decimals || 0;
              scope.value = scope.value ? scope.value : (scope.data.displayAs === 'progressBar' ? 0 : null);
              scope.textColor = parseInt(scope.value) === 0 ? '#000' : '#fff';

              scope.getColor = function (value) {

                  var defaultBlueColor = '#337ab7';

                  value = parseFloat(value);

                  if (!scope.data.colorThresholds || !scope.data.colorThresholds.percents) {
                      return defaultBlueColor;
                  }

                  var colors = angular.copy(scope.data.colorThresholds.colors && scope.data.colorThresholds.colors.length ? scope.data.colorThresholds.colors : ['#d9534f', '#f0ad4e', '#5cb85c']);

                  if (value < _us.first(scope.data.colorThresholds.percents)) {
                      return _us.first(colors);
                  }

                  if (value >= _us.last(scope.data.colorThresholds.percents)) {
                      return _us.last(colors);
                  }

                  var color = null;
                  colors.pop();
                  colors.shift();

                  scope.data.colorThresholds.percents.forEach(function (threshold, index) {
                      if (!color && value < parseInt(threshold)) {
                          color = colors[index] || _us.last(colors);
                      }
                  });

                  return color;
              };
          }
      };
  });
